import * as React from "react";
import {inject, observer} from "mobx-react";

import {ButtonInline} from "@ok/common/design-system/components/ButtonInline";
import {ClipsFullscreenController} from "../../../../lib/ClipsFullscreenController";
import {l10n} from "@ok/web/modules/l10n/l10n";

const l10NPkg = l10n("clips");

interface IClose {
    ctrl?: ClipsFullscreenController;
}

export const Close: React.FC<IClose> = inject("ctrl")(observer(
    (props): React.ReactElement => {
        const ctrl = props.ctrl!;
        const store = ctrl.store!;

        const handleClose = () => {
            if (!store.isNavigationRunning) {
                ctrl.handleClose();
            }
        };

        return (
            <ButtonInline
                data-tsid={" "}
                size={"32"}
                view={"primary-on-color"}
                state={store.isNavigationRunning ? "loading" : "enabled"}
                aria-label={l10NPkg.getLMsg("closeClipsLayer")}
                onClick={handleClose}
            >
                <ButtonInline.LeftIcon icon={"glyph_close_24+"}/>
                <ButtonInline.Loader label={"loader"}/>
            </ButtonInline>
        );
    }
));

